import config from '../config'
import Helmet from 'react-helmet'
import React from 'react'

function helmet(title, url){
  const propTitle = config.app.title + ' - ' + title
  url = url || config.domain
  return(
    <Helmet title={title}
      meta={[
        {property: 'og:url', content: url},
        {property: 'twitter:title', content: propTitle },
        {property: 'og:site_name', content: propTitle },
        {property: 'og:title', content: propTitle },
      ]}
    />
  )
}
export default {
  helmet,
}